import { render, staticRenderFns } from "./base_upload.vue?vue&type=template&id=0dac2ec0&scoped=true&"
import script from "./base_upload.vue?vue&type=script&lang=js&"
export * from "./base_upload.vue?vue&type=script&lang=js&"
import style0 from "./base_upload.vue?vue&type=style&index=0&id=0dac2ec0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dac2ec0",
  null
  
)

export default component.exports